// extracted by mini-css-extract-plugin
module.exports = {"scoreCardTable":"ScoreBoard_scoreCardTable_DRtUy"};